import BodyType from 'owa-service/lib/contract/BodyType';
import { mutatorAction } from 'satcheljs';
import { CompositeEditorViewState } from '../store/schema/CompositeEditorViewState';
import { ComposeEditorType } from 'owa-mail-preferred-editor';
import {
    editorToBodyType,
    setPreferredEditorTypeInStorage,
} from 'owa-mail-preferred-editor/lib/preferredEditorTypes';

const setPreferredEditorType = mutatorAction(
    'Editor_SetPreferredEditorType',
    (
        viewState: CompositeEditorViewState,
        bodyType: BodyType,
        composeEditorType: ComposeEditorType
    ) => {
        if (editorToBodyType[composeEditorType] != bodyType) {
            throw new Error(
                `Tried to set editor ${composeEditorType} for unsupported BodyType ${bodyType}`
            );
        }

        viewState.preferredEditors[bodyType] = composeEditorType;

        setPreferredEditorTypeInStorage(viewState.bodyType, composeEditorType);
    }
);

export default setPreferredEditorType;
